import { PieChart } from 'echarts/charts';
import { use } from 'echarts/core';
import { colorScale } from 'volta/utils/style-utils';

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

import type IntlService from 'ember-intl/services/intl';
import type { EChartsOption } from 'volta/components/bv-chart';
import type { IImportResult } from 'volta/models/types/data-import';

use([PieChart]);

interface IArgs {
  importResult?: IImportResult;
}

export default class ImportHistoResultChart extends Component<IArgs> {
  @service intl!: IntlService;

  get chartOptions(): EChartsOption {
    const {
      totalRows = 0,
      newRows = 0,
      updatedRows = 0,
      deletedRows = 0
    } = this.args.importResult ?? {};

    const data =
      totalRows > 0
        ? [
            {
              value: newRows,
              itemStyle: { color: colorScale('green', '2') },
              name: this.intl.t('new')
            },
            {
              value: updatedRows,
              itemStyle: { color: colorScale('indigo', '2') },
              name: this.intl.t('updated')
            },
            {
              value: deletedRows,
              itemStyle: { color: colorScale('red', '2') },
              name: this.intl.t('deleted')
            },
            {
              value: Math.max(totalRows - newRows - updatedRows - deletedRows, 0),
              itemStyle: { color: colorScale('gray', '2') },
              name: this.intl.t('unchanged')
            }
          ]
        : [];

    return {
      grid: { left: 0, top: 0, bottom: 0, right: 0 },
      legend: null,
      tooltip: {
        trigger: 'item'
      },
      series: [
        {
          name: this.intl.t('results'),
          // @ts-ignore - Do not recognize the type
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: true
            }
          },
          tooltip: {},
          labelLine: {
            show: false
          },
          data
        }
      ]
    };
  }
}
